<template>
  <div id="app">
    <a-spin :spinning="getAxiosLoading" size="large">
      <a-config-provider :locale="locale">
        <router-view />
      </a-config-provider>
    </a-spin>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import zhCN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zhCN')
export default {
  name: 'mainHander',
  data() {
    return {
      // spinning: getAxiosLoading,
      locale: zhCN,
    }
  },

  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters(['getAxiosLoading']),
  },
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  font-size: 16px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
